import { cn } from '@eliadmin/core/src/utils/style-utils';

export const BlogSkeletonItem = ({ firstBlog = false }: { firstBlog?: boolean }) => {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-4 sm:gap-6 lg:gap-8',
        firstBlog
          ? 'col-span-1 sm:col-span-2 md:mb-2 md:flex-row md:items-center md:justify-between lg:mb-4'
          : 'col-span-1 items-start justify-start',
      )}
    >
      <div
        className={cn(
          'relative h-[205px] w-full max-w-[913px] bg-slate-200',
          firstBlog
            ? 'sm:h-[300px] lg:h-[420px] xl:h-[520px]'
            : 'md:h-[240px] lg:h-[300px] xl:h-[440px]',
        )}
      />
      <div className="flex w-full flex-col items-start justify-start gap-4">
        <div className="flex w-full flex-col items-start justify-start gap-2">
          <div className="h-[25px] w-full bg-slate-200 sm:h-[27px] lg:h-[30px] xl:h-[35px]" />
          <div className="h-[25px] w-[80%] bg-slate-200 sm:h-[27px] lg:h-[30px] xl:h-[35px]" />
        </div>
        <div className="flex w-full flex-col items-start justify-start gap-1">
          <div className="h-[14px] w-[90%] bg-slate-200 sm:h-[17px] xl:h-[18px]" />
          <div className="h-[14px] w-[95%] bg-slate-200 sm:h-[17px] xl:h-[18px]" />
          <div className="h-[14px] w-[40%] bg-slate-200 sm:h-[17px] xl:h-[18px]" />
        </div>
        <div className="flex w-full items-center justify-end">
          <div className="h-12 w-full bg-slate-200 sm:w-[198px]" />
        </div>
      </div>
    </div>
  );
};
